module.exports = __webpack_public_path__ + "img/achievement-course4.d8d1e420.png";